import React, { useState, useEffect } from 'react';
import './ModiFyRegistrationDetails.css'
import Form from 'react-bootstrap/Form';
import InfoPopover from '../Common/InfoPopover';
import ProjectsService from '../../Services/ProjectsService';
import PhoneInput, {
  isValidPhoneNumber
} from 'react-phone-number-input';

import 'react-phone-number-input/style.css';
import ServiceRequestModel from './ServiceRequestModel';
import OtpInputModal from '../Company/OtpInputModal';
import SRQService from '../../Services/SRQService';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

const isValidEmail = (value) =>
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/.test(value);
const isValidDisplayName = (value) =>
  /^[\p{L}\p{M}]+(?:[ .'-][\p{L}\p{M}]+)*$/u.test(value.trim());

const ReplaceAnAccountableRepresentative = ({ company, confirmedRepId, usrExist, restrctFld, onCancel }) => {

  const [isCreateSRQButtonActive, setIsCreateSRQButtonActive] = useState(false);
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const [OtpDataFromModal, setOtpDataFromModal] = useState([]);

  const [modalShow, setModalShow] = React.useState(false);
  var otpInputModelOpenendForAction = '';

  const [selectedRequestTypeCompany, setSelectedRequestTypeCompany] = useState(company);
  const [existingCompany, setExistingCompany] = useState([]);

  const [accountCountryCode, setAccountCountryCode] = useState("");
  const [accountAdditionalDetails, setAccountAdditionalDetails] = useState("");

  const [accountCheck, setAccountCheck] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabledCRepSelector, setIsDisabledCRepSelector] = useState(false);

  const [email, setEmail] = useState("");
  const [isEmailTouched, setIsEmailTouched] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [isDisplayNameTouched, setIsDisplayNameTouched] = useState(false);

  const [message, setMessage] = useState(" ");

  const [responseMessage, setResponseMessage] = useState(" ");

  const [selectedRequestTypeCompanyCRep, setSelectedRequestTypeCompanyCRep] = useState("");



  const [representativePhoneNumber, setRepresentativePhoneNumber] = useState('')



  function handleEmail(event) {
    let inputValue = event.target.value;
    setEmail(inputValue);
    if (inputValue && !isValidEmail(inputValue)) {
      setMessage("Email Id is invalid");
    } else {
      setMessage("");
    }
  }
  const handleDisplayName = (event) => {
    let eValue = event.target.value;
    setDisplayName(eValue);
  }


  const handleAccountCheckBox = (event) => {
    let isChecked = event.target.checked;
    if (isChecked) {
      setDisplayName("");
      setIsDisplayNameTouched(false);
    }
    setAccountCheck(isChecked);
  }



  const handleSelectChange = (event) => {
    let eValue = event.target.value;
    setSelectedRequestTypeCompany(eValue);
    setSelectedRequestTypeCompanyCRep("");
    setAccountAdditionalDetails("");
    setDisplayName("");
    setIsDisplayNameTouched(false);
    setEmail("");
    setIsEmailTouched(false);
    setMessage("");
    setRepresentativePhoneNumber("");
    setIsDisabled(false);

    if (eValue == "Select Existing Company") {
      setIsDisabledCRepSelector(true);
    } else {
      companyCrepDetails(eValue);
      setIsDisabledCRepSelector(false);
    }
  }

  const handleClearCompanySelection = () => {
    setSelectedRequestTypeCompany("");
    setIsDisabledCRepSelector(true);
    setIsDisabled(false);
    setSelectedRequestTypeCompanyCRep("");
    setAccountAdditionalDetails("");
    setDisplayName("");
    setIsDisplayNameTouched(false);
    setEmail("");
    setIsEmailTouched(false);
    setMessage("");
    setRepresentativePhoneNumber("");
  };

  const handleClearCRepSelection = () => {
    setSelectedRequestTypeCompanyCRep("");
    setAccountAdditionalDetails("");
    setDisplayName("");
    setIsDisplayNameTouched(false);
    setEmail("");
    setIsEmailTouched(false);
    setMessage("");
    setRepresentativePhoneNumber("");
    setIsDisabled(true);
  };

  const [cRepresentatives, setCRepresentatives] = useState([]);
  // async function companyCrepDetails(companyId) {
  //   await ProjectsService.getCompaniesCrepDetails(companyId)
  //   .then((response) => {
  //     setCRepresentatives(response.data.representatives);
  //     console.log(response.data);
  //   }).catch(error =>{
  //     console.log(error);
  //   });
  // }

  async function companyCrepDetails(companyId) {
    setCRepresentatives([]);
    try {
      const response = await ProjectsService.getCompaniesCrepDetails(companyId);
      setCRepresentatives(response.data.representatives || []);
      console.log("Fetched cRepresentatives:", response.data.representatives);
    } catch (error) {
      console.error("Error fetching representatives:", error);
      setCRepresentatives([]);
    }
  }



  const handleSelectChangeCrep = (event) => {
    let eValue = event.target.value;
    setSelectedRequestTypeCompanyCRep(eValue);
    if (eValue == "Select Existing CRep") {
      setAccountAdditionalDetails("");
      setDisplayName("");
      setIsDisplayNameTouched(false);
      setEmail("");
      setIsEmailTouched(false);
      setMessage("");
      setRepresentativePhoneNumber("");
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }


  const onServiceRequestCreated = () => {
    console.log("inside onServiceRequestCreated function")
    clearAllFields();
    setModalShow(false);
    window.location.href = "/viewserviceRequests";
  };
  function clearAllFields() {
    setSelectedRequestTypeCompanyCRep("");
    setEmail("");
    setIsEmailTouched(false);
    setMessage("");
    setDisplayName("");
    setIsDisplayNameTouched(false);
    setRepresentativePhoneNumber("");
    setAccountAdditionalDetails("");
  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        backdrop='static'
        keyboard="False"
        dialogClassName='my-modal'



      >
        <Modal.Header className='modal-header'>
          <Modal.Title id="contained-modal-title-vcenter">
            Confirmation on  service request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <p>
            {responseMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="ui button comm-button-style primary" onClick={onServiceRequestCreated}>OK</button>
        </Modal.Footer>
      </Modal>
    );
  }



  async function createSRQ() {
    console.log("HI FROM Creeate company")
    if (
  !accountCheck &&
  !isValidPhoneNumber(representativePhoneNumber)
) {
  return;
}
    //e.preventDefault();
    setIsCreateSRQButtonActive(true);
    //userDetailsObject.password=password;


    otpInputModelOpenendForAction = "registerCompany";
    setOtpModalOpen(true);

    // 
    try {
      const response = await ProjectsService.getStrongConfirmationCode("POST", null, "registerCompany", null, null, null)
      if (response && response.data.channel == "SMS") {
        otpInputModelOpenendForAction = "registerCompany";


        setOtpModalOpen(true);
        // alert("otp entered from otp modal for deleting credentials is ---->" + OtpDataFromModal);
      }


    } catch (error) {
      console.log(error);
    }
    // setModalShow(true);  //enable here for modal testing

  }
  const resendOtp = async () => {
    await ProjectsService.getStrongConfirmationCode("POST", null, "registerCompany", null, null, null);
  }



  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  }

  async function verifyOtp(OtpDataFromModal) {

    if (OtpDataFromModal.length !== 0) {

      console.log(OtpDataFromModal)
      OtpDataFromModal = Number(OtpDataFromModal.join(''));
      //alert("otp:"+OtpDataFromModal)
      ServiceRequestModel.companyId = selectedRequestTypeCompany;
      // ServiceRequestModel.projectId=null;
      ServiceRequestModel.requestType = "ReplaceCRep";
      ServiceRequestModel.requestText = accountAdditionalDetails.replace(/(?:\r\n|\r|\n)/g, ' ');
      //var existingEmail = cRepresentatives.filter((r) => r.id ==  selectedRequestTypeCompanyCRep)
      //   .map((cr) => {return cr.email;});
      //ServiceRequestModel.subjectExistingUser.email=existingEmail[0];
      ServiceRequestModel.subjectExistingUser.email = selectedRequestTypeCompanyCRep;
      ServiceRequestModel.subjectNewUser.displayName = displayName.trim();
      ServiceRequestModel.subjectNewUser.email = email;
      ServiceRequestModel.subjectNewUser.mobile = representativePhoneNumber;
      // ServiceRequestModel.subjectCompany.name=newCompanyName;

      console.log(ServiceRequestModel);


      // alert("userDetailsObject.password"+userDetailsObject.password);

      const response = await SRQService.createNewServiceRequest(ServiceRequestModel, OtpDataFromModal)
        .then((response) => {
          setResponseMessage(response.data.message);
          setModalShow(true);
          setOtpModalOpen(false);
          window.location.href = "/viewserviceRequests";
        }).catch(error => {
          // Check if it's an APIM error - let global interceptor handle those
          if (error.response?.data?.code?.startsWith('APIM-')) {
            console.log('APIM error, letting global interceptor handle it');
          } else {
            toast.error(error.response.data.message);
          }
          console.log(error);
        });

    }

  }
  useEffect(() => {
    if (company) {
      companyCrepDetails(company);
    }

    ProjectsService.getAllProjects()
      .then((response) => {
        let dataRequest = (response.data[0]?.companyProjects || []);
        setExistingCompany(dataRequest);

        //alert(dataRequest);
        var allCompany = '';
        dataRequest.forEach(companyObj => { allCompany = allCompany + companyObj.name + ', ' })
        //alert(allCompany);
        if (usrExist === 'false') {
          setAccountCheck(false);
          //setIsDisabled(true);
          var msg = 'Please remove my association from the below companies and then delete my account.'
            + '\nList of Companies: ' + allCompany;
          setAccountAdditionalDetails(msg);
        }

      })
      .catch((error) => console.error("Error fetching projects:", error));

  }, [company]);


  useEffect(() => {


    if (confirmedRepId && cRepresentatives.length > 0) {
      const numericConfirmedRepId = Number(confirmedRepId); // Convert confirmedRepId to a number
      const defaultRep = cRepresentatives.find(rep => rep.id === numericConfirmedRepId);

      if (defaultRep) {

        if (defaultRep.email) {
          setSelectedRequestTypeCompanyCRep(defaultRep.email);
          console.log("Setting selectedRequestTypeCompanyCRep to:", defaultRep.email);
        }
      } else {
        console.log("No representative found matching confirmedRepId.");
      }
    }
  }, [confirmedRepId, cRepresentatives]);







  //  useEffect(() => {
  //   if(company!==null)

  //   {companyCrepDetails(company);}
  //       ProjectsService.getAllProjects().then((response) => {
  //         setExistingCompany(response.data[0].companyProjects);
  //       }).catch(error =>{
  //         console.log(error);
  //       });
  //     },[])
  //     useEffect(() => {
  //       if (confirmedRepId && cRepresentatives && cRepresentatives.length > 0) {
  //         const defaultRep = cRepresentatives.find(rep => rep.id === confirmedRepId);
  //         if (defaultRep) {
  //           setSelectedRequestTypeCompanyCRep(defaultRep.email);
  //         }
  //       }
  //     }, [confirmedRepId, cRepresentatives]);

      const customstyles = {
        dropdownindicator: base => ({
          ...base,
          fill: "red" // custom colour
        })
      };

      const handleCancel = () => {
          clearAllFields();
          if (onCancel) {
            onCancel();
          }
      }


      const renderEmailbox = () =>{
  return(
    <>
    <li>
        <div className="custom-input-wrapp mb-4">
          <input
            type="email"
            className="inputText"
            tabIndex={1}
            required
            id="inputEmailCrep"
            placeholder="Email Id"
            maxLength={256}
            disabled={isDisabled || !hasRequiredSelections}
            aria-invalid={
              (isEmailTouched && !email.trim()) ||
              (Boolean(email) && !isValidEmail(email))
            }
            value = {email} 
            onChange = {e => handleEmail(e)}
            onBlur={() => setIsEmailTouched(true)}
              style={{
                  width: "100%",
                  height: "45px",
                  border: ((isEmailTouched && !email.trim()) ||
                    (Boolean(email) && !isValidEmail(email)))
                    ? "1px solid red"
                    : "1px solid #cfd4dc",
                  borderRadius: "6px",
                  padding: "10px 15px",
                  fontSize: "16px",
                  color: "#2323a5",
                  backgroundColor: "#fff"
       }}
          />
          <span className="input-info-label ms-0">Eg: username@domain.com</span>
          <span className="required-field-op">(Required)</span>
          {isEmailTouched && !email.trim() ? (
            <div style={{ color: "red" }}>Email is required</div>
          ) : message ? (
            <div style={{ color: "red" }}>{message}</div>
          ) : null}
        </div>
      </li>
    </>
  )
}

  const hasRequiredSelections =
    Boolean(selectedRequestTypeCompany) &&
    selectedRequestTypeCompany !== "Select Existing Company" &&
    Boolean(selectedRequestTypeCompanyCRep) &&
    selectedRequestTypeCompanyCRep !== "Select Existing CRep";
  const canCreate =
    !isCreateSRQButtonActive &&
    hasRequiredSelections &&
    isValidEmail(email) &&
    ((!accountCheck && isValidDisplayName(displayName) && isValidPhoneNumber(representativePhoneNumber)) ||
      accountCheck);

  return (
    <>
      <li>
        <div className="sec">
          <div className="head-titlw-w head-titl-unset">
            <h3
              style={{ fontSize: "15px" }}
              className="sec-title"
              id="ManageCompany-ModifyCompany-promptForModifyCompany"
              data-info=""
            >
              REPLACE AN ACCOUNTABLE REPRESENTATIVE
            </h3>
          </div>
          <ul className="serv-req sec-inner-wrap">
            <li style={{
              opacity: (usrExist === 'false' || restrctFld === 'true') ? 0.60 : 1,
              pointerEvents: (usrExist === 'false' || restrctFld === 'true') ? 'none' : 'initial'
            }}>
              <div
                className="dropdown-w-info mt-3"
                id="selectModifyCompanyWrapper"
                style={{ display: "flex", position: 'relative' }}
              >
                {selectedRequestTypeCompany ? (

                  <span
                    id='clear-icon-ReplaceAccRep-company'
                    className="clear-icon-ReplaceAccRep-company no-ligatures"
                    onClick={handleClearCompanySelection}
                  >
                    &times;
                  </span>
                ) : (
                  <i className="dropdown icon" />
                )}
                <div className="width-full">
                  <Form.Select
                    defaultValue="Select Existing Company"
                    value={selectedRequestTypeCompany}
                    onChange={handleSelectChange}
                    styles={customstyles}
                    style={{ width: "100%" }}
                    className={selectedRequestTypeCompany ? 'dropdown-with-close' : 'dropdown-default'}
                  >
                    <option className="textdefault">
                      {"Select Existing Company"}
                    </option>

                    {existingCompany &&
                      existingCompany.map((cp) => {
                        //alert(cp.name);
                        return <option value={cp.id} >{cp.name}</option>;
                      })}
                  </Form.Select>
                </div>
                <InfoPopover
                  id="infoPopOverModifyCompany"
                  className="info-icon-w ms-2"
                  content={"Please select the relevant company."}
                  ariaLabel="Information: select company"
                />
              </div>
            </li>


            <li style={{
              opacity: (usrExist === 'false' || restrctFld === 'true') ? 0.60 : 1,
              pointerEvents: (usrExist === 'false' || restrctFld === 'true') ? 'none' : 'initial'
            }}>
              <div
                className="dropdown-w-info mt-3"
                style={{ display: "flex", position: 'relative' }}
              >
                {selectedRequestTypeCompanyCRep ? (

                  <span
                    id='clear-icon-Crep-ReplaceAccRep'
                    className="clear-icon-Crep-ReplaceAccRep no-ligatures"
                    onClick={handleClearCRepSelection}
                  >
                    &times;
                  </span>
                ) : (
                  <i className="dropdown icon" />
                )}
                <div className="width-full">
                  <Form.Select
                    //defaultValue="Select Existing CRep"
                    value={selectedRequestTypeCompanyCRep || "Select Existing CRep"}
                    onChange={handleSelectChangeCrep}
                    styles={customstyles}
                    style={{ width: "100%" }}
                    disabled={isDisabledCRepSelector || selectedRequestTypeCompany === ""}
                    className={selectedRequestTypeCompanyCRep ? 'dropdown-with-close' : 'dropdown-default'}
                  >
                    <option className="textdefault">
                      {"Select Existing CRep"}
                    </option>

                    {cRepresentatives &&
                      cRepresentatives
                        .filter((r) => r.isConfirmed)
                        .map((cr) => {
                          return <option value={cr.email}>{cr.name}</option>;
                        })}
                  </Form.Select>
                </div>
                <InfoPopover
                  id="infoPopOverModifyRepresentative"
                  className="info-icon-w ms-2"
                  content={"Select the representative to be removed. Only accountable representatives are available in the list. If you wish to replace a delegate you can use the self-service portal to do so by editing the company details and replacing the delegate directly from the list of delegates."}
                  ariaLabel="Information: select representative"
                />
              </div>
            </li>

            <>
              <div className="awesome">
                <ul className="serv-req sec-inner-wrap">
                  <li className="user-exist-w" style={{
                    opacity: (usrExist === 'false' || restrctFld === 'true') ? 0.60 : 1,
                    pointerEvents: (usrExist === 'false' || restrctFld === 'true') ? 'none' : 'initial'
                  }}>
                    <div className="form-check mb-3">
                      <label className="mt-2 form-check-label">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="remember"
                          onChange={(e) => handleAccountCheckBox(e)}
                          defaultChecked={usrExist == 'false' ? false : accountCheck}
                          disabled={isDisabled}
                        />{" "}
                        User already exist
                      </label>
                    </div>
                  </li>

                  {accountCheck && accountCheck ? (
                    <>{renderEmailbox()}</>
                  ) : (
                    <>
                      <li id="inputDisplayNameCrepWrapper" style={{}}>
                        <div className="custom-input-wrapp mb-4">
                          <input
                            type="text"
                            className="inputText"
                            required=""
                            maxLength={240}
                            tabIndex={1}
                            id="inputDisplayNameCrep"
                            placeholder="Display Name"
                            disabled={isDisabled}
                            value={displayName}
                            onChange={e => handleDisplayName(e)}
                            onBlur={() => setIsDisplayNameTouched(true)}
                            aria-invalid={
                              (isDisplayNameTouched && !displayName.trim()) ||
                              (Boolean(displayName.trim()) && !isValidDisplayName(displayName))
                            }
                            style={{
                              width: "100%",
                              height: "45px",
                              border: "1px solid #cfd4dc",
                              borderRadius: "6px",
                              padding: "10px 15px",
                              fontSize: "16px",
                              color: "#2323a5",
                              backgroundColor: "#fff"
                            }}
                          />
                          <span className="input-info-label">
                            Eg: Jane Doe
                          </span>
                          <span className="required-field-op">
                            (Required)
                          </span>
                          {isDisplayNameTouched && !displayName.trim() ? (
                            <div style={{ color: "red" }}>Display Name is required</div>
                          ) : displayName.trim() && !isValidDisplayName(displayName) ? (
                            <div style={{ color: "red" }}>
                              Display Name is invalid.
                            </div>
                          ) : null}
                        </div>
                      </li>
                      {renderEmailbox()}
                      <li
                        className="select-drop-message"
                        id="inputMobileNoCrepWrapper"
                        style={{}}
                      >
                        <div className="contact-num-wrap">
                          <div className="country-code-w">
                            <div className="phone-input-wrapper">
  <PhoneInput
    international
    value={representativePhoneNumber}
    onChange={(value) => {
      setRepresentativePhoneNumber(value || '');
    }}
    placeholder="Enter phone number"
    disabled={isDisabled}
  />
</div>


                          </div>
                          <span className="required-field-op">(Required)</span>

                        </div>
                      </li>
                    </>
                  )}

                  <li>
                    <div className="custom-input-wrapp mt-3 mb-3">
                      <div className="dropdown-w-info">
                        <div className="width-full">
                          <textarea
                            className="cust-text-a"
                            maxLength={4000}
                            placeholder="Additional Details"
                            id="textAreaModifyAdditionalDetails"
                            tabIndex={1}
                            style={{ fontSize: '14px' }}
                            value={accountAdditionalDetails}
                            onChange={(e) =>
                              setAccountAdditionalDetails(e.target.value)
                            }
                            disabled={!selectedRequestTypeCompanyCRep || selectedRequestTypeCompanyCRep === ""}
                          />
                        </div>
                        <InfoPopover
                          id="infoPopOverModifyAdditionalDetails"
                          className="info-icon-w pop-common-sel sr-pophover visible ms-2"
                          content={"Please provide any additional information relevant to the change and to the registration process of the new user here."}
                          ariaLabel="Information: additional details"
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </>
          </ul>
        </div>
      </li>
      <li className="apim-pop-button-w comm-button-wrap ser-req-btn">
        {canCreate ?
          <button
            className="comm-button-style primary btn-disable"
            tabIndex={1}
            onClick={() => createSRQ()}
          >
            Create
          </button> :
          <button className="button comm-button-style primary btn-disable" id="btnSubmitRegisterCompany" tabindex="1"
            disabled>{!isCreateSRQButtonActive ? <>Create</> : <>Creating Service Request..</>}</button>
        }
        <button
          type="button"
          className="button comm-button-style secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </li>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      {/* ✅ Using global ToastContainer from App.js - removed local instance */}
      {OtpModalOpen && <OtpInputModal ModalHeading={""} setOpenOtpModal={setOtpModalOpen} handleOtp={handleOtp} value={OtpDataFromModal} verifyOtp={verifyOtp} credentialRecord={""} otpInputModelOpenendForAction={otpInputModelOpenendForAction} resendOtp={resendOtp} />}

    </>
  );
}
export default ReplaceAnAccountableRepresentative;